import React from 'react'

export const Header = () => {
  return (
    <h2 className="title">
      Expense Tracker
    </h2>
  )
}
